<template>
    <v-combobox v-model="selectedItemsFormatted" :items="itemsFormatted" multiple chips return-object hide-details :label="label" class="compact" @change="$emit('change', selectedItemsFormatted)">
        <template v-slot:item="data" class="1234">
            <v-list-item-avatar>
                <img :src="getImage(data.item)">
            </v-list-item-avatar>
            <v-list-item-content>
                    <v-list-item-title v-html="data.item.text"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
            </v-list-item-content> 

        </template>

        <template v-slot:selection="data">
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                <v-chip v-on="on"
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove(data.item)"
                >
                    <v-avatar style="height:40px;width:40px;margin-right:10px">
                    <img :src="getImage(data.item)">
                    </v-avatar>
                    {{ data.item.text }}
                </v-chip>
                </template>
                <span>{{getHintText(data.item)}}</span>
            </v-tooltip>
        </template>        
    </v-combobox>
</template>

<script>
import OrderHelpers from '../helpers/OrderHelpers'
// 
import ContactHelpers from '../helpers/ContactHelpers';
import DataHelpers from '../helpers/DataHelpers';
import Utilities from '../helpers/Utilities';
import StringHelpers from '../helpers/StringHelpers';

export default {
    data() {
        return {
        
        }
    },
    
    props: {
        value: Array, 
        items: Array,
        label: String,
    },

    components: {
        
    },

    computed: {
        

        itemsFormatted() {
            return this.formatForCombo(this.items)
        }, 
        
        selectedItemsFormatted: {
            get: function () {
                //console.log('get function run', this.value)
                return this.formatForCombo(this.value)
            },
            set: function (passedValue) {

                let cleanedContacts = this.cleanContacts(passedValue)
                //console.log('set function run', cleanedContacts)
                this.$emit('input', cleanedContacts)
                this.$emit('change', cleanedContacts)
            }
        }   
    },

    methods: {
        getImage(item) {
            return item.image || '/static/images/user.png'
        },

        getHintText(item) {
            return (item.role ? item.role + ': ' : '') + item.email
        },

        cleanContacts(items) {
            //convert plain email into a contact object with an email
            let newItems = []
            items.forEach(item => {
                if(!Utilities.isObject(item)) {
                    if(StringHelpers.isEmail(item)) {
                        let newItem = {
                            key: DataHelpers.getKey(),
                            email: item,
                        }
                        newItems.push(newItem)
                    }
                } else {
                    newItems.push(item)
                }
            })
            return newItems
        },

        formatForCombo(items) {
            if(!items)
                return []
            return items.map(contact => {
                let newContact = {...contact}
                if(!contact || !contact.key) {
                    console.error('no contact key in formatforcombo')
                    return
                }
                newContact.text = newContact.fullName || ContactHelpers.fullName(newContact) || newContact.email
                    
                newContact.value = newContact.key.toString()
                return newContact
            })            
        },

        remove (item) {
            let selectedItems = [...this.selectedItemsFormatted]
            const index = selectedItems.findIndex(o => o.value == item.value)
            if (index >= 0) {
                selectedItems.splice(index, 1)
                this.selectedItemsFormatted = selectedItems
            }
        }

    }
}
</script>

<style scoped>
.calendar-day {
    padding:10px;border-bottom:solid 1px #eee;
}
</style>




// WEBPACK FOOTER //
// ContactAutocomplete.vue?33335db1